
import { Routes, RouterModule } from '@angular/router';

import { TelaAjudaComponent } from './area-cliente/portal/tela-ajuda/tela-ajuda.component';
import { TelaSuporteComponent } from './area-cliente/portal/tela-suporte/tela-suporte.component';
import { TelaNoticiasComponent } from './area-cliente/portal/tela-noticias/tela-noticias.component';
import { TelaBoletoComponent } from './area-cliente/portal/tela-boleto/tela-boleto.component';
import { TelaPrincipalComponent } from './area-cliente/portal/tela-principal/tela-principal.component';

const ROUTES: Routes = [
  { path: 'boleto', component: TelaBoletoComponent },
  { path: 'ajuda', component: TelaAjudaComponent },
  { path: 'suporte/:url_destino', component: TelaSuporteComponent },
  { path: 'suporte', component: TelaSuporteComponent },
  { path: 'noticias', component: TelaNoticiasComponent },
  { path: ':numeroDeSerie', component: TelaPrincipalComponent },
  { path: '', redirectTo: 'suporte', pathMatch: 'full' }
];

export const routing = RouterModule.forRoot(ROUTES, { useHash: true });


// WEBPACK FOOTER //
// C:/Disco D/Projetos/central-cliente/src/app/app.routing.ts